// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/modules/products/NewProductPrompt/NewProductPrompt.css
// module id = 1904
// module chunks = 0